import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { ActionsGroup, InfoGroup, VoiceSkeletonWrapper } from './index.style';

const SkeletonText = ({ width }) => (
  <Skeleton
    style={{ borderRadius: '50px' }}
    variant="rectangular"
    width={width}
    height={12}
  />
);

const SkeletonCircle = ({ size }) => (
  <Skeleton variant="circular" width={size} height={size} />
);

const VoiceSkeleton = () => (
  <VoiceSkeletonWrapper>
    <Box display="flex" alignItems="center" gap="16px">
      <SkeletonCircle size={40} />
      <InfoGroup>
        <SkeletonText width={115} />
        <Box display="flex" gap={1} alignItems="center">
          <SkeletonText width={68} />
          <SkeletonCircle size={8} />
          <SkeletonText width={32} />
          <SkeletonCircle size={8} />
          <SkeletonText width={40} />
        </Box>
      </InfoGroup>
    </Box>

    <Box display="flex" alignItems="center" gap="8px" justifyContent="center">
      <Skeleton
        style={{ borderRadius: '50px' }}
        variant="rectangular"
        width={24}
        height={24}
      />
      <InfoGroup>
        <SkeletonText width={40} />
        <SkeletonText width={29} />
      </InfoGroup>
    </Box>

    <Box display="flex" alignItems="center" gap="32px" marginLeft="25px">
      {[...Array(3)].map((_) => (
        <Box key={_} display="flex" gap="8px" alignItems="center">
          <SkeletonCircle size={16} />
          <SkeletonText width={26} />
        </Box>
      ))}
    </Box>

    {/* Action Buttons */}
    <ActionsGroup>
      {[...Array(2)].map((_) => (
        <Skeleton
          key={_}
          style={{ borderRadius: '4px' }}
          variant="rectangular"
          width={24}
          height={24}
        />
      ))}
    </ActionsGroup>
  </VoiceSkeletonWrapper>
);

export default VoiceSkeleton;
